import md5 from 'blueimp-md5';
import stringify from 'json-stable-stringify';
import { ErrorTracking } from '../config';

// set of the form data md5 hashes
const dataHashes = [];

const getCheckSum = (data) => {
  try {
    return md5(stringify(data)).toString();
  } catch (e) {
    ErrorTracking.error('Unable to create md5 hash!', e);
    return '';
  }
};

export const getCheckSumIndex = (data) => {
  const checksum = getCheckSum(data);
  const index = dataHashes.indexOf(checksum);

  if (index === -1) {
    return dataHashes.push(checksum);
  }
  return index;
};
